
import { create } from "zustand";
import { devtools } from "zustand/middleware";





const storeApi = (set) => ({

    totalReproteStock: 0,



});





export const useReporteStockStore = create(
    devtools(
        storeApi
    )
)
